import { render, staticRenderFns } from "./SpkbDelivery.vue?vue&type=template&id=2adade8d&"
import script from "./SpkbDelivery.vue?vue&type=script&lang=js&"
export * from "./SpkbDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports